<template>
  <el-empty description="404">
    <el-button type="primary" round size="small" @click="goBack">返回上一页</el-button>
    <el-button type="danger" round size="small" @click="logOut">退出登录</el-button>
  </el-empty>
</template>

<script>
import API from '@/api'

export default {
  methods: {
    goBack() {
      this.$router.back()
    },

    logOut() {
      API.logout().then(() => {
        this.$store.dispatch('user/logout')
        this.$router.replace('/login')
      })
    }
  }
}
</script>
